<template>
  <div class="searchList">
    <div class="box-content">
      <label class="form-tit">订单编号</label>
      <el-input
        v-model="searchData.sign_order_no"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">订单名称</label>
      <el-input
        v-model="searchData.title"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">缴费时间</label>
      <el-date-picker
        class="jm-input280"
        v-model="searchData.last_payment_time"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
    </div>
    <div class="box-content">
      <label class="form-tit">是否缴齐</label>
      <jm-dict-select
        class="jm-input280"
        clearable
        v-model="searchData.is_complete"
        type="dataset"
        dict-type="student"
        name="isTover"/>
    </div>
    <div class="box-content">
      <label class="form-tit">学生姓名</label>
      <el-input
        v-model="searchData.student_name"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">电话号码</label>
      <el-input
        v-model="searchData.telphone"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">学校名称</label>
      <gkry-school-search
        class="jm-input280"
        clearable
        v-model="searchData.school_id"
        @change="changeSchool()" />
    </div>
    <div class="box-content">
      <label class="form-tit">届别</label>
      <el-input
        v-model="searchData.school_year"
        class="jm-input280"/>
    </div>
    <div class="box-content">
      <label class="form-tit">报名班级</label>
      <el-select
        class="jm-input280"
        clearable
        v-model="searchData.class_id" >
        <el-option
          v-for="option in classes"
          :value="option.id"
          :label="option.name"
          :key="option.id">
          {{ option.name }}
        </el-option>
      </el-select>
    </div>
    <div class="box-content">
      <label class="form-tit">创建时间</label>
      <el-date-picker
        class="jm-input280"
        v-model="searchData.create_time"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
    </div>
    <div class="box-content">
      <label class="form-tit">学生编码</label>
      <el-input
        v-model="searchData.student_id"
        class="jm-input280"/>
    </div>
  </div>
</template>
<script>
import gkrySchoolSearch from './gkrySchoolSearch';

function gkrySearchData() {
  return {
    sign_order_no: '',
    title: '',
    last_payment_time: [],
    is_complete: '',
    student_name: '',
    telphone: '',
    school_id: '',
    school_year: '',
    class_id: '',
    create_time: [],
    student_id: '',
    site_name: 'gkry'
  };
}

export default {
  props: {
    searchData: {
      type: Object,
      default: gkrySearchData(),
    },
  },
  data() {
    return {
      classes: []
    };
  },
  methods: {
    gkryInitSearchData() {
      return gkrySearchData();
    },
    changeSchool () {
      this.$http._post({
        url: 'finance/gkry/fetchClass',
        data: {
          school_id: this.searchData.school_id,
          school_year: this.searchData.school_year
        }
      }).then(({ data }) => {
        this.classes = data;
      }).catch((res) => {
        console.log(res);
      });
    }
  },
  components: {
    gkrySchoolSearch
  },
  mounted() {
  },
  watch: {
    searchData: {
      handler: function (newValue) {
        this.$emit('update:searchData', newValue);
      },
      deep: true
    }
  }
};
</script>
